/**
 * Hotel URL helpers.
 *
 * slugifyHotelName is an EXACT mirror of slugifyHotelName() in
 * functions/hotel-page/index.js. The hotelPage function builds its
 * <link rel="canonical"> as /hotel/{id}/{slugifyHotelName(name)}, so every
 * internal link must use this same logic to land on the canonical URL
 * (no "duplicate, different canonical" in Search Console, no wasted crawls).
 *
 * If you change the slug rules here, change them in the function too.
 */
export function slugifyHotelName(value) {
  return (
    String(value || 'property')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 100) || 'property'
  )
}

/** Canonical hotel path (no query string), e.g. /hotel/lp1897/the-manhattan-at-times-square-hotel */
export function hotelPath(id, name) {
  return `/hotel/${id}/${slugifyHotelName(name)}`
}
